const INITIAL_LOADING_ELEMENT_ID = 'app-loader';

export function getInitialLoadingElement(): HTMLElement | null {
  if (typeof document === 'undefined') return null;
  return document.getElementById(INITIAL_LOADING_ELEMENT_ID);
}

export function preserveInitialLoadingElement(): void {
  const initialLoadingElement = getInitialLoadingElement();
  if (!initialLoadingElement || initialLoadingElement.parentElement === document.body) return;

  // Moving the existing node preserves the running CSS animation while React
  // takes ownership of #root. Appending it also keeps the overlay above the app.
  document.body.append(initialLoadingElement);
}

export function removeInitialLoadingElement(): void {
  getInitialLoadingElement()?.remove();
}
